import { render, staticRenderFns } from "./Cv_text_field.vue?vue&type=template&id=0645d6ee&scoped=true&"
import script from "./Cv_text_field.vue?vue&type=script&lang=js&"
export * from "./Cv_text_field.vue?vue&type=script&lang=js&"
import style0 from "./Cv_text_field.vue?vue&type=style&index=0&id=0645d6ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645d6ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
